import { render, staticRenderFns } from "./FacebookAdPreview.vue?vue&type=template&id=368fd9d1&"
import script from "./FacebookAdPreview.vue?vue&type=script&lang=js&"
export * from "./FacebookAdPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports